import React, { useEffect, useState } from 'react';
import api from '../api/client';

interface Props { invoiceId: number; onBack: () => void; }

export default function PurchaseInvoiceDetail({ invoiceId, onBack }: Props) {
  const [inv, setInv] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const fmt = (n: any) => Number(n||0).toLocaleString('en-US', { minimumFractionDigits:2, maximumFractionDigits:2 });

  useEffect(() => {
    api.get(`/supplier-invoices/${invoiceId}`).then(r => { setInv(r.data.data); setLoading(false); });
  }, [invoiceId]);

  if (loading) return <div className="empty-state"><p>Loading...</p></div>;
  if (!inv) return <div className="empty-state"><p>Not found.</p></div>;

  return (
    <div>
      <div className="page-header" id="no-print">
        <button className="btn btn-secondary" onClick={onBack}>Back</button>
        <button className="btn btn-primary" onClick={() => window.print()}>Print</button>
      </div>
      <div className="card" id="print-area">
        <div style={{ padding:'20px 24px', borderBottom:'1px solid var(--bdr)', display:'flex', justifyContent:'space-between' }}>
          <div>
            <div style={{ fontSize:20, fontWeight:700 }}>{inv.invoice_no}</div>
            <div style={{ fontSize:12, color:'var(--tx3)', marginTop:4 }}>Supplier Invoice &mdash; {inv.status}</div>
          </div>
          <div style={{ textAlign:'right', fontSize:12, color:'var(--tx3)' }}>
            <div>Invoice Date: {inv.invoice_date ? new Date(inv.invoice_date).toLocaleDateString() : '-'}</div>
            {inv.due_date && <div>Due: {new Date(inv.due_date).toLocaleDateString()}</div>}
            <div>Supplier Ref: {inv.supplier_invoice_no || '-'}</div>
          </div>
        </div>
        <div style={{ padding:'16px 24px', borderBottom:'1px solid var(--bdr)', display:'flex', justifyContent:'space-between' }}>
          <div>
            <div style={{ fontSize:12, color:'var(--tx3)', marginBottom:4 }}>Supplier</div>
            <div style={{ fontWeight:600 }}>{inv.supplier_name}</div>
          </div>
          <div style={{ textAlign:'right' }}>
            <div style={{ fontSize:12, color:'var(--tx3)', marginBottom:4 }}>Branch</div>
            <div style={{ fontWeight:600 }}>{inv.branch_name || '-'}</div>
          </div>
        </div>
        <div style={{ padding:'24px', display:'flex', justifyContent:'flex-end' }}>
          <div style={{ textAlign:'right' }}>
            <div style={{ fontSize:13, color:'var(--tx3)', marginBottom:4 }}>Invoice Amount</div>
            <div style={{ fontSize:28, fontWeight:700, color:'var(--red)' }}>{fmt(inv.invoice_amount)}</div>
          </div>
        </div>
        {inv.notes && <div style={{ padding:'12px 24px', fontSize:12, color:'var(--tx3)', borderTop:'1px solid var(--bdr)' }}>Notes: {inv.notes}</div>}
      </div>
      <style>{`@media print { #no-print { display:none !important; } }`}</style>
    </div>
  );
}